
document.addEventListener("DOMContentLoaded", function () {

  const isProductPage = document.querySelector(".product-form");

    if (isProductPage) {
        handleVariantChange();
    }

    function handleVariantChange() {

        const productForm = document.querySelector("product-form");


        if (!productForm) {
        return; // Exit early if 'product-form' is not found
        }


        const selectedVariantDiv = document.createElement("div");
        selectedVariantDiv.classList.add("selected-variant");


        const variantSelected = document.querySelector("variant-picker summary.disclosure__title span.variant_selected");
        const variantSpan = document.createElement("span");
        variantSpan.classList.add("variant_selected");

        if (variantSelected) {
        variantSpan.textContent = variantSelected.textContent;  // Set initial text
        selectedVariantDiv.appendChild(variantSpan);


        const targetElement = document.querySelector(".product-info .media-gallery-size-medium + .product-column-right .product-form .title-row");
        if (targetElement) {
            targetElement.appendChild(selectedVariantDiv); // Append to the targeted element
        }
        }


        const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            // Check if the mutation is for the text content of variant_selected
            if (mutation.target === variantSelected && mutation.type === "childList") {

              variantSpan.textContent = variantSelected.textContent;
          }
        });
      });


        if (variantSelected) {
        observer.observe(variantSelected, { childList: true, subtree: true });
      }
    }
  /* Quick Buy */
  const quickbuyToggle = document.querySelectorAll("a.quickbuy-toggle");

  quickbuyToggle.forEach(toggle => {
    toggle.addEventListener("click", function () {
      setTimeout(() => {
        const titleRow = document.querySelector('.quickbuy-container .inner .detail .title-row');

        if (titleRow) {
          // Reuse existing or create new selected variant element
          let selectedVariantDiv = titleRow.querySelector('.selected-variant');
          if (!selectedVariantDiv) {
            selectedVariantDiv = document.createElement('div');
            selectedVariantDiv.classList.add('selected-variant');
            titleRow.appendChild(selectedVariantDiv);
          }

          // Add change listener to each input for updating variant text
          document.querySelectorAll('.quickbuy-container .product-form__input input').forEach(input => {
            input.addEventListener('change', () => {
              if (input.checked) {
                const selectedValue = input.value;
                selectedVariantDiv.textContent = selectedValue;

                // Update variant text in disclosure title, if present
                const variantTextElement = document.querySelector('.disclosure .disclosure__title span.variant_selected');
                if (variantTextElement) {
                  variantTextElement.textContent = selectedValue;
                }
              }
            });
          });
        } else {
          // console.error("The titleRow element was not found.");
        }
      }, 3000);
    });
  });
});



